import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DashboardsDisplayGridRowDataFragmentGql } from './DashboardsDisplayGridRowFragmentGql';

export const VirtualConnectionTableDownstreamDashboardsQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamDashboardsQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamDashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowDataFragment
      }
    }
  }
}
${DashboardsDisplayGridRowDataFragmentGql}
`;
